import { Box } from '@mui/material'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Layout } from '@/bootstrap/typings'
import Breadcrumbs from '@/components/AppBar/components/Breadcrumbs'
import { SidebarNav } from '@/components/Sidebar/SidebarNav'
import { env } from '@/env'
import { beforeLoad } from '@/integrations/oidc/route-authenticated-beforeload'

export const Route = createFileRoute('/_authenticated')({
	staticData: {
		layout: Layout.full,
	},
	// beforeLoad läuft bei jedem Deeplink/Navigation
	beforeLoad(params) {
		if (!env.VITE_AUTH_TOKEN) {
			return beforeLoad(params, redirect)
		}
		return undefined
	},
	component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
	return (
		<Box
			sx={{
				blockSize: '100dvh',
				inlineSize: '100vw',
				overflow: 'hidden',
				display: 'flex',
				flexDirection: 'row',
				backgroundColor: 'background.default',
			}}
		>
			<Box
				sx={{
					flex: '0 0 auto',
					height: '100%',
					minHeight: 0,
					maxHeight: '100%',
				}}
			>
				<SidebarNav />
			</Box>
			<Box
				sx={{
					flex: 1,
					minWidth: 0,
					display: 'flex',
					flexDirection: 'column',
					minHeight: 0,
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						flex: '0 0 auto',
						p: 2,
						pb: 1,
						borderBottom: 1,
						borderColor: 'divider',
						bgcolor: 'background.paper',
					}}
				>
					<Breadcrumbs />
				</Box>
				<Box
					sx={{
						flex: 1,
						minHeight: 0,
						minWidth: 0,
						p: 2,
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<Outlet />
				</Box>
			</Box>
		</Box>
	)
}
